module.exports = __webpack_public_path__ + "static/media/instagram.ded75d64.png";